export const CreateEditDupOrderEnum = {
  NEW: '0',
  EDIT: '1',
  DUP: '2',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ManageIngredientEnum.js